import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { PagedContactTypeResponse } from '../../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { VehicleModelEditComponent } from '../../../features/vehicle/vehicle-model-edit/vehicle-model-edit.component'
import { VehicleModelService } from '../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { VehicleModelCreateComponent } from '../../../features/vehicle/vehicle-model-create/vehicle-model-create.component'
import { SearchVehicleModelModel } from '../../../core/models/vehicle-model.model'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'vehicle-model',
  imports: [
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    VehicleModelCreateComponent,
    FormSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './vehicle-model.component.html',
  styleUrl: './vehicle-model.component.scss',
  providers: [VehicleModelService, AuthService],
  standalone: true,
})
export class VehicleModelComponent implements OnInit {
  constructor(
    private manufacturerService: VehicleModelService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = true
  searchForm: SearchVehicleModelModel = new SearchVehicleModelModel()
  inputSearch: string = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'manufacturer',
      key: 'nome',
      description: 'Fabricante',
    },
    {
      keyColumn: 'contato-telefone',
      key: 'contato',
      description: 'Telefone',
    },
    {
      keyColumn: 'contato-email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'modelo veículo'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.modelo = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchVehicleModelModel()
    }
    if (this.searchForm.modelo) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.manufacturerService
      .listVehicleModel()
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.manufacturerService
      .searchPagedVehicleModel(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(VehicleModelEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      minWidth: '75dvw',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
